<template>
    <div>
        <h1>
        <el-page-header @back="goBack" :content="pageExchangeRule.name.concat('选品')">
        </el-page-header>
        </h1>
        <el-card class="form-container" shadow="never">
            <el-button type="primary" @click="showDetails('添加选品')">添加选品</el-button>
        </el-card>
        <el-card class="form-container" shadow="never">
            <el-table border
                      :data="selectList"
                      height="690"
                      style="width: 100%">
                <el-table-column  label="日期" prop="good.dtUpdate" :formatter="switchDate">
                </el-table-column>
                <el-table-column  label="平台来源" >
                    <template slot-scope="scope" >
                        {{scope.row.good.origin===1 ?'蜂助手':'其它'}}
                    </template>
                </el-table-column>
                <el-table-column  label="商品类型" prop="good.goodsType.name" ></el-table-column>
                <el-table-column  label="商品名称" prop="good.name" ></el-table-column>
                <el-table-column  label="商品图片" width="150px" align="center">
                    <template slot-scope="scope">
                        <template>
                            <img :src="VUE_APP_CDN_URL+scope.row.good.goodImg" width="80px" height="80px" />
                        </template>
                    </template>
                </el-table-column>
                <el-table-column  label="规格/面值" prop="good.goodValue" ></el-table-column>
                <el-table-column  label="单品编码" prop="good.goodCode" ></el-table-column>
                <el-table-column  label="标准价" prop="good.price" ></el-table-column>
                <el-table-column  label="供货价" prop="good.discountPrice" sortable ></el-table-column>
                <el-table-column  label="商品详情"  >
                    <template slot-scope="scope">
                        <el-button type="text" @click.native.stop="checkGoodDesc(scope.row.good)" >查看</el-button>
                    </template>
                </el-table-column>
                <el-table-column  label="排序" >
                    <template slot-scope="scope" >
                        <el-input-number size="small" :min="0" style="width: 110px" v-model="scope.row.rank"  @change="update(scope.row)" ></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column  label="状态"  align="center" width="140px">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.state"
                                   :active-value="1"
                                   :inactive-value="0"
                                   active-text="开启"
                                   inactive-text="关闭"
                                   @change="update(scope.row)">
                        </el-switch>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="1234px" :before-close="cancel">
                <el-table border
                          ref="multipleTable"
                          :data="goodList"
                          tooltip-effect="dark"
                          style="width: 100%"
                          @selection-change="handleSelectionChange"
                          stripe
                          :row-key="getRowKeys"
                          :row-class-name="gameRowTableClass"
                         >
                    <el-table-column
                            type="selection"
                            :reserve-selection="true"
                            width="55">
                    </el-table-column>
                    <el-table-column  label="ID" prop="id"  ></el-table-column>
                    <el-table-column  label="日期" prop="dtUpdate" :formatter="formatDate" width="160px"></el-table-column>
                    <el-table-column  label="平台来源" width="100px" >
                        <template slot-scope="scope" >
                            {{scope.row.origin===1 ?'蜂助手':'其它'}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="商品类型" prop="goodsType.name" width="100px"></el-table-column>
                    <el-table-column  label="商品名称" prop="name" width="90px"></el-table-column>
                    <el-table-column  label="商品图片" width="150px" align="center">
                        <template slot-scope="scope">
                            <template>
                                <img :src="VUE_APP_CDN_URL+scope.row.goodImg" width="80px" height="80px" />
                            </template>
                        </template>
                    </el-table-column>
                    <el-table-column  label="规格/面值" prop="goodValue" width="90px"></el-table-column>
                    <el-table-column  label="单品编码" prop="goodCode" width="137px"></el-table-column>
                    <el-table-column  label="标准价" prop="price" width="100px"></el-table-column>
                    <el-table-column  label="供货价" prop="discountPrice" sortable width="100px"></el-table-column>

                </el-table>

                <h1 style="text-align: center;">
                    <el-button type="primary" @click="confirm">确 定</el-button>
                    <el-button type="info" @click="cancel">取 消</el-button>
                </h1>

        </el-dialog>
        <el-dialog title="商品描述" center :visible.sync="dialogGoodDescVisible" width="50%" :data="desc" >
            <el-row type="info" v-for="(item, index) in desc " :key="index">{{item}}</el-row>
        </el-dialog>
    </div>
</template>

<script>
    import {
        selectList,
        selectUpdate,
        listGoods,
        selectGoods
    }from "@/http/api";
    import utils from '@/utils';
    export default {
        name: "SelectGood",
        data(){
            return{
                pageExchangeRule: {},
                goodList:[],
                selectForm:{},
                selectList:[],
                VUE_APP_CDN_URL:'',
                dialogTitle:'',
                multipleSelection: [],
                dialogVisible : false,
                goodSelectors :{},
                dialogGoodDescVisible:false,
                desc:[]
            }
        },
        methods: {
            goBack() {
                this.$router.push({path: '/goodsConfig'});
            },
            formatDate: function(row, column) {
                return utils.DateUtil.formatDate(row[column.property], "YYYY-MM-DD HH:mm:ss")
            },
            switchDate:function(row){
                return utils.DateUtil.formatDate(row.good.dtUpdate, "YYYY-MM-DD HH:mm:ss")
            },
            getRowKeys(row){
                return row.id
            },
            gameRowTableClass({row,rowIndex}){
                row.index=rowIndex
            },
            queryList(){
                selectList(this.pageExchangeRule.id).then(resp => {
                    this.selectList = resp.data.info;
                })
            },
            goodsList(){
                listGoods().then(resp => {
                    this.goodList = resp.data.info;
                    this.selectList.forEach(item => {
                        this.$refs.multipleTable && this.$refs.multipleTable.toggleRowSelection(item.good, true)
                    })
                })
            },
            checkGoodDesc(_row){
                console.log(_row)
                this.dialogGoodDescVisible=true;
                this.desc = _row.goodDesc.split("\n").length===1?['暂无内容']: _row.goodDesc.split("\n")
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            showDetails(title) {
                this.dialogTitle = title;
                this.dialogVisible = true;
                this.goodsList();

            },
            clear(){
                this.$refs.multipleTable.clearSelection();
            },

            confirm(){
                let goodIds =[];
                this.goodSelectors.exchangeId = this.pageExchangeRule.id;
                this.goodSelectors.rank = 0;
                this.goodSelectors.state = 1;
                this.multipleSelection.forEach(item =>{
                    goodIds.push(item.id)
                });
                this.goodSelectors.goodIds = goodIds;
                selectGoods(this.goodSelectors).then(resp=> {
                    if (resp.data.status===0){
                        this.dialogVisible=false;
                        this.queryList();
                    }
                });
            },
            cancel(){
                this.clear();
                this.dialogVisible=false;
            },
            update(row){
                this.selectForm = {
                    "id" : row.id,
                    "rank" :row.rank,
                    "state" : row.state,
                    "goodId" : row.good.id,
                    "exchangeId" : row.exchange.id
                };

                selectUpdate(this.selectForm).then(resp=> {
                    if (resp.data.status===0){
                        this.queryList();
                    }
                })
            }
        },
        created() {
            this.pageExchangeRule = this.$store.state.exchangeRule;
            this.queryList();
        },
        mounted() {
            this.VUE_APP_CDN_URL= process.env.VUE_APP_CDN_URL;
        }
    }
</script>

<style scoped>

</style>